import { useAPI } from '#/hooks/index.js';
import { useSelector } from 'react-redux';
import { interpolationSelector } from '#/store/slices/interpolation.js';
import { useCallback } from 'react';

export default function useInterpolation() {
  const API = useAPI();
  const dict = useSelector(interpolationSelector);

  return useCallback(
    (template) => API.interpolation.interpolate(template, dict),
    [API, dict],
  );
}
